module.exports = __webpack_public_path__ + "static/media/SFST_2.bf34fcdd.mp4";